import React,{ useState } from "react"

import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
function PerformancePlanRows({rowsData, deleteTableRows, handleChange,enableEdit,isReview}) {
    return(
        
        rowsData.map((data, index)=>{
            const {performanceplan, dependency}= data;
            return(
                <tr key={index}>
                <td>
                <Input
                    type="textarea"
                    placeholder="Enter the goal here."
                    name="performanceplan"
                    onChange={(evnt)=>(handleChange(index, evnt))}
                    value={performanceplan}
                    disabled={isReview?'':'disabled'}
                    />
                </td>
                <td>
                <Input
                    type="textarea"
                    placeholder="Explain the dependency."
                    name="dependency"
                    onChange={(evnt)=>(handleChange(index, evnt))}
                    value = {dependency}
                    disabled={isReview?'':'disabled'}
                    />
                </td>
               
                <td><button type="button" 
                className="btn btn-outline-danger" 
                onClick={()=>(deleteTableRows(index))}
                style={isReview?{display:"block"}:{display:"none"}}
                >x</button></td>
            </tr>
            )
        })
   
    )
    
}
export default PerformancePlanRows;